export default {
  navBar:{
    proposal: 'Proposal',
    language: '语言',
    login: 'Sign In',
    logout: 'Sign Out',
    SystemAdmin:'SysManage',
    UserCenter:'User Center',
    userCenterinfo:'User information',
    applylist:'Application List',
    authlist:'Authorization list',
    downloadlist:'Downloaded list',
    homepage:'Homepage',
    goback:'go back',
  },
  proposal:{
    obs_id:'Obs ID',
    schedule_id:'Schedule ID',
    ptype:'Type',
    ptype_data:{
      C:'Core Proposal',
      T:'ToO Proposal',
      G:'Guest Proposal',
      M:'Temp Proposal',
    },
    obs_mode:'Obs Mode',
    obsmode_data:{
      P:'Pointing',
      S:'ASS, All Sky Survey',
      A:'SAS, Small Area Survey',
    },
    target:'Target',
    ra:'Ra',
    dec:'Dec',
    offset:'OffAxis Flag',
    offset_c:'offset',
    tstart:'Data Start(TT)',
    tsop:'Data Stop(TT)',
    start_utc:'Data Start(UTC)',
    stop_utc:'Data Stop(UTC)',
    duration:'Duration',
    status:'Status',
    status_data:{
      A:'Archived',
      P:'Processing',
      O:'Obsolete',
      U:'Unavailable',
    },
    isopen:'Open',
    isopenstate:'Open:',
    isopen_data:{
      0:'Protecting',
      1:'Opened',
    },
    operate:'Operation',
    apply:'Apply',
    bulk_down:'Bulk down',
    batch_application:'Batch APPL*',
    copy_downlink:'Copy DownLink',
    get_wget:'Get wget command',
    webdownload:'Browser download',
    bulkcopy_downlink:'Copy DownLink',
    bulkget_wget:'Get wget command',
    bulkwebdownload:'Browser download',
    download:'Download',
    UpPackage:'UpPackage',
    OwnerAuth:'Owner Link generation',
    full_name:'Full name',
    email:'E-mail address',
    applycop:'organization',
    application_information:'Application',
    ok:'OK',
    cancel:'Cancel',
    id:'Proposal ID',
    pre_slew:'Pre-Slew',
    post_slew:'Post-Slew',
    data_mode:'DataMode',
    proposal:'Proposal',
    observer:'Observer',
    speed:'Scan Speed',
    interval:'Scan Interval',
    radius:'Scan Radius',
    release_time:'ReleaseTime',
    open_time:'Open Time',
    location: 'Location',
    owner:'Owner',
    archive_time:'Archive time',
    l1_file_id:'1L file ID',
    l15_file_id:'1.5 file ID',
    l2_file_id:'2L file ID',
    l1_file_v:'1L FileVersion',
    l15_file_v:'1.5 FileVersion',
    l2_file_v:'2L FileVersion',
    create_time:'Create time',
    create_by:'Create by',
    update_time:'Update time',
    update_by:'Update by',
    condition: {
      target: 'Target',
      position: 'Position',
      radius: 'Radius(°)',
      start_utc: 'Obs.Start',
      stop_utc: 'Obs.End',
      isopen: 'Only Public Data',
      ptype: 'Proposal Type',
      obs_mode:'Obs Mode',
      schedule_id: 'Schedule ID',
      tstart: 'Obs-Begin(MET or MJD) ',
      tstop: 'Obs-End(MET or MJD)',
      proposal: 'Proposal',
      isarchived: 'Only Archived Data',
      all: 'All',
      download: 'Only Download',
      appliable: 'Only Appliable',
      more: 'More Search Conditions',
      search: 'Search',
      clear:'Clear',
      less: 'Less Search Conditions',
    },
    tip:{
      obs_id:'Observation ID',
      schedule_id:'Schedule ID in Observation Schedule',
      tstart:'Data start time(TT)',
      tsop:'Data end time(TT)',
      duration:'Tstop - Tstart',
      pre_slew:'Time Length of Slew before Obs',
      post_slew:'Time Length of Slew after Obs',
      target:'Observe Target',
      obs_mode:'Observe Mode',
      data_mode:'Data Mode',
      proposal:'Proposal ID',
      ptype:'Proposal Type',
      status:'Data Status',
      speed:'Scan Speed',
      Interval:'Scan Interval',
      radius:'Scan Radius',
      offset:'Offset Flag',
      offset_c:'Calculation radius',
      isopen:'Data Open Status: 1 open  ，0  non open',
      release_time:'Time of Data Release',
      open_time:'Time of Data Open',
    },
  },
  grb:{
    grb_id:'GRB_ID',
    trigger_time:'Trigger Time(MJD)',
    trigger_time_utc:'Trigger Time(UTC)',
    start_utc:'Data start time(UTC)',
    start_tt:'Data start time(TT)',
    duration:'Duration',
    status:'Status',
    relate_id:'Relate_ID',
    filesize:'File size',
    apply:'Apply',
    bulk_down:'Bulk down',
    copy_downlink:'Copy DownLink',
    get_wget:'Get wget command',
    download:'Download',
    condition: {
      grb_id: 'GRB ID',
      obs_from: 'Obs.From',
      obs_to: 'Obs.To',
      search: 'Search',
    },
    tip:{
      grb_id:'GRB ID by HXMT',
      start_utc:'Data start time(ISO 8601)',
      start_tt:'Data start time(HXMT-TT)',
      duration:'Tstop - Tstart',
      status:'Data Status',
    },
  },
  sem:{
    date_utc:'Obs. Date(UTC)',   
    date_mjd:'Obs. Date(mjd)',    
    hxmt_day:'HXMT Day Index',
    start_tt:'Data start time(TT)',
    stop_tt:'Data end time(TT)',
    duration:'Duration',
    status:'Status',
    apply:'Apply',
    bulk_down:'Bulk down',
    copy_downlink:'Copy DownLink',
    get_wget:'Get wget command',
    download:'Download',
    condition: {
      obs_from: 'Obs.From',
      obs_to: 'Obs.To',
      search: 'Search',
    },
    tip:{
      date_utc:'Data start time(ISO 8601)',
      date_mjd:'Data start time(MJD)',
      duration:'Tstop - Tstart',
      status:'Data Status',
    },
  },
  messinfo:{
    applying:'Applying, please wait for email reply.',
    positioninput:'Ra Dec Radius is a set of input conditions, which must be combined',
    rainput:'ra is a float in the range [0,360), or a string in (hh mm ss.ss) format, hh range [0,24) integer, mm range [0,60) integer, ss range [0,60) float, Please check!',
    decinput:'des is a float in the range [-90,90], or a string in (dd ff mm.mm) format, dd range [-90,90] integer, ff range [0,60) integer, mm range [0,60) float, Please check!',
    radiusinput: 'radius is a float greater than 0, please check!',
  },
  noLoginApplyDialog: {
    id:'Data ID',
    ogs_id:'Ogs ID',
    remark:'Application purpose',
    application_information: 'Tourist data application',
    name: 'Full Name',
    applyemail: 'Email',
    applycop: 'Organization',
    cancel: 'Cancel',
    ok: 'OK',
    level:'Data level',
    messinfo:{
      select_datalevel:'Please select data level!',
      lack_information:'Please fill in all the application information (name, purpose, email address, organization)!',
      mailbox_detection:'Incorrect email format!',
    },
    
  },
  LoginApplyDialog: {
    application_information: 'User Application Information',
    appbulk_information: 'Batch application information',
    name: 'Full Name',
    useremail: 'Email',
    applycop: 'Organization',
    cancel: 'Cancel',
    ok: 'OK',
    id:'ID',
    obs_id:'Obs ID',
    proposal:'Proposal ID',
    remark:'Purpose',
    userposition:'Post',
    userposition_tip:'Select Post',
    tutorinfo:'Tutor information',
    tutorname:'Tutor name',
    tutoremail:'Tutor email',
    tutoropion:'Tutor opion',
    partnersinfo:'Partner information',
    partnersname:'Partner name',
    partnersemail:'Partner email',
    partnersopion:'Partner opion',
    includeproposal:{
      one:'Apply this data',
      two:'Apply this proposal data',
      three:'Apply same target data under this proposal',
    },
    required:' * Required ',
    messinfo:{
      useremailbox_detection:'User email format is not correct, please contact the registration system administrator!',
      userposition:'Select position!',
      student:'Data purpose, tutor name, tutor email is required, please check!',
      tutormailbox_detection:'Tutor email format is incorrect!',
      core:'Data purpose is required, please check!',
      noncore:'Data purpose, partner name, partner email is required, please check!',
      partnersemail_detection:'Partner email format is incorrect!',
    },
  },
  LoginApplyDialogAppByPm: {
    application_information: 'User Application Information',
    appbulk_information: 'Batch application information',
    name: 'Full Name',
    useremail: 'Email',
    applycop: 'Organization',
    cancel: 'Cancel',
    ok: 'OK',
    id:'ID',
    obs_id:'Obs ID',
    proposal:'Proposal ID',
    remark:'Purpose',
    userposition:'Post',
    userposition_tip:'Select Post',
    tutorinfo:'Tutor information',
    tutorname:'Tutor name',
    tutoremail:'Tutor email',
    tutoropion:'Tutor opion',
    partnersinfo:'Partner information',
    partnersname:'Partner name',
    partnersemail:'Partner email',
    partnersopion:'Partner opion',
    includeproposal:{
      one:'Apply this data',
      two:'Apply this proposal data',
      three:'Apply same target data under this proposal',
    },
    required:' * Required ',
    messinfo:{
      useremailbox_detection:'User email format is not correct, please contact the registration system administrator!',
      userposition:'Select position!',
      student:'Data purpose, tutor name, tutor email is required, please check!',
      tutormailbox_detection:'Tutor email format is incorrect!',
      core:'Data purpose is required, please check!',
      noncore:'Data purpose, partner name, partner email is required, please check!',
      partnersemail_detection:'Partner email format is incorrect!',
    },
  },
  ObsInfo:{
    title:'Observation Details',
    homepage:'Homepage',
  },
  ProposalInfo:{
    title:'Proposal Details',
    homepage:'Homepage',
  },
  TargetInfo:{
    title:'Target Details',
    homepage:'Homepage',
    src_name:'Target',
    ra:'ra',
    dec:'dec',
    obs_id:'Obs ID',
    obs_time:'Observation Time',
    duration:'Duration',
    flux_h:'flux_h',
    flux_m:'flux_m',
    flux_l:'flux_l',
  },
  QuickLookInfo:{
    title:'QuickLook',
    homepage:'Homepage',
  },
  DataRelease:{
    filepath:'File Path',
    filesign:'File Sign',
    filever:'File version',
    ver:'File ver',
    fileid:'File ID',
    filelength:'File Size',
    check:'Check',
    release:'Release',
    level:{
      '1L':'1L',
      '15L':'1.5L',
      '2L':'2L',
    },
  },
  AdminIndexdata:{
    visinfo:'Tourist application information',
    usrinfo:'User application information',
    datatime:'Data time',
  },
  UserVerify:{
    applicant:'UserEmail',
    closever:'Cancel authorization',
    Applicationtype:'Application type',
    includeproposal:{
      1:'Obs Data',
      2:'Proposal Data',
      3:'Same target Data',
    },
  },
  DataUppackage:{
    title:'Data upgrade package download window',
  },
};
